import { BlogCategory } from '@/constants/blog.const';
import type { StrapiBlogCategory } from '@/types/blog';

export const getBlogCategoryFromStrapiBlogCategory = (
  strapiBlogCategory: StrapiBlogCategory
): BlogCategory => {
  switch (strapiBlogCategory) {
    case 'Reviews':
      return BlogCategory.Reviews;
    case 'Guides':
      return BlogCategory.Guides;
    case 'Tips':
      return BlogCategory.Tips;
    case 'News':
      return BlogCategory.News;
    case 'Betting':
      return BlogCategory.Betting;
    default:
      strapiBlogCategory satisfies never;
      throw new Error(`Unknown blog category: ${strapiBlogCategory}`);
  }
};

export function getStrapiBlogCategoryFromBlogCategory(
  blogCategory: BlogCategory
): StrapiBlogCategory {
  switch (blogCategory) {
    case BlogCategory.Reviews:
      return 'Reviews';
    case BlogCategory.Guides:
      return 'Guides';
    case BlogCategory.Tips:
      return 'Tips';
    case BlogCategory.News:
      return 'News';
    case BlogCategory.Betting:
      return 'Betting';
    default:
      blogCategory satisfies never;
      throw new Error(`Unknown blog category: ${blogCategory}`);
  }
}
